import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';
import { Spinner } from 'src/components/Spinner';

const ButtonContent = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { loading, icon, children, customIcon } = props;

  return (
    <React.Fragment>
      {/* The product's one indicator, inheriting the button's own colour —
          it was FontAwesome's `faSpinner`, a solid six-spoke mark in an app
          whose icons are all stroked, turning at a different rate from the
          one every page showed. */}
      {loading ? <Spinner size={15} /> : null}
      {!loading ? <span>{children}</span> : null}
      {!loading && (icon || customIcon) ? (
        <div className="form-control-icon">
          <FontAwesomeIcon
            icon={customIcon ? customIcon : faArrowCircleRight}
          />
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default ButtonContent;
